import { Directive, Input, ElementRef, AfterViewInit, OnChanges } from '@angular/core';
import { Observable } from 'rxjs';
@Directive({
  selector: '[readMore]'
})

export class ReadMoreDirective implements AfterViewInit, OnChanges {
  @Input('readMore-length') private maxLength: number;
  @Input('readMore-element') private elementChange: HTMLElement;
  @Input('text-change') private isTextChanged: Observable<any>;

  private currentText: string;
  private hideToggle: boolean = true;
  private text: string;
  private isCollapsed: boolean = true;
  counter: number = 0;
  eventExecute:boolean=false;

  constructor(private el: ElementRef) {
  }

  ngOnInit() {
    this.isTextChanged.subscribe((response: any) => {
      if(response !== 'DEFAULT_MESSAGE'){
        if (response.status == 'CHANGED') {
          this.text = response.text;
          if (this.text.length <= this.maxLength) {
            this.el.nativeElement.classList.add('display-none');
          } else {
            this.toggleView(true);
            if (!this.hideToggle) {
              this.el.nativeElement.classList.remove('display-none');
            } else {
              this.el.nativeElement.classList.add('display-none');
            }
          }
  
          if (this.counter == 0) {
            this.el.nativeElement.addEventListener('click', (event: MouseEvent) => {
              event.preventDefault();
              if(!this.eventExecute){
                this.toggleView();
                this.eventExecute=false;
              }
            });
          }

          this.counter=0;
        }
        else if(response.status == 'RESET'){
          this.counter=0;
          this.eventExecute=false;
        }
      }      
    });
  }

  /**
   * @inheritDoc
   */
  public ngAfterViewInit(isUpdate?) {
    this.text = this.elementChange.innerHTML;
    if (this.text.trim().length > 0)
      this.counter++;
    if (this.text.length <= this.maxLength) {
      this.el.nativeElement.classList.add('display-none');
    } else {
      this.toggleView(isUpdate);
      if (!this.hideToggle) {
        this.el.nativeElement.classList.remove('display-none');
      } else {
        this.el.nativeElement.classList.add('display-none');
      }

      this.el.nativeElement.addEventListener('click', (event: MouseEvent) => {
        this.eventExecute=true;
        event.preventDefault();
        this.toggleView();
      });
    }
  }

  /**
   * @inheritDoc
   */
  public ngOnChanges() {
    if (this.text)
      this.toggleView();
  }
  /**
   * Toogle view - full text or not
   */
  private toggleView(isUpdate?): void {
    this.determineView(isUpdate);
    this.isCollapsed = !this.isCollapsed;
    if (this.isCollapsed) {
      this.el.nativeElement.querySelector('.more').style.display = "none";
      this.el.nativeElement.querySelector('.less').style.display = "inherit";
    } else {
      this.el.nativeElement.querySelector('.more').style.display = "inherit";
      this.el.nativeElement.querySelector('.less').style.display = "none";
    }
  }

  /**
   * Determine view
   */
  private determineView(isUpdate?): void {
    const _elementChange = document.getElementById(this.elementChange.id);
    if (this.text.length <= this.maxLength) {
      this.currentText = this.text;
      _elementChange.innerHTML = this.currentText;
      this.isCollapsed = false;
      this.hideToggle = true;
      return;
    }

    this.hideToggle = false;

    if (isUpdate) {
      this.isCollapsed = true;
    }

    if (this.isCollapsed === true) {
      this.currentText = this.text.substring(0, this.maxLength) + '...';
      _elementChange.innerHTML = this.currentText;
    }
    else if (this.isCollapsed === false) {
      this.currentText = this.text;
      _elementChange.innerHTML = this.currentText;
    }
  }
}
